module.exports = __webpack_public_path__ + "static/media/2_3.3f364223.jpg";